import React, { FC } from 'react'
import BarGraphBase from './BarGraphBase'
import Scale from '../Scale'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

interface Props {
  title: string,
  value: number,
  checked: boolean,
}

const MonthlyHeaderBarGraph: FC<Props> = (props) => {
  const {
    title,
    value,
    checked,
  } = props

  const { t } = useTranslation()

  return (
    <>
      <div className="item_title">
        <AnchorLink
          offset="160"
          data-gtm-click={`${t(`report.monthly.score.${title}`)} - anchor_link_text`}
          href={`#${title}`}
        >
          {t(`report.monthly.score.${title}`)}
        </AnchorLink>
      </div>
      <div className={`item ${checked && "checked"}`}>
        {
          checked && (
            <ReactSVG
              src="/static/images/icon/icon-warn.svg"
              className="icon_warn"
            />
          )
        }
        <div className="text_area">
          <span>
            {value}
          </span>
        </div>
        <BarGraphBase
          value={value}
        />
        <AnchorLink
          offset="160"
          data-gtm-click={`${t(`report.monthly.score.${title}`)} - anchor_link_button`}
          href={`#${title}`}
          className="link_button"
        >
          <FontAwesomeIcon icon={['fas', 'angle-down']} className="icon" />
        </AnchorLink>
      </div>
      <div className="item">
        <div className="text_area" />
        <div className="label">
          <Scale />
        </div>
        <div
          style={{
            minWidth: "38px",
          }}
        />
      </div>

    </>
  )
}

export default MonthlyHeaderBarGraph
